import { z } from 'zod';

const crestSchema = z
	.object({
		url: z.string().optional(),
		alt: z.string().optional(),
		altText: z.string().optional(),
		imageVariants: z.array(z.unknown()).optional(),
	})
	.passthrough();

const teamSchema = z
	.object({
		optaId: z.number().optional(),
		name: z.string().optional(),
		shortName: z.string().optional(),
		// Freeform may return numeric or string scores (e.g. "4").
		score: z.union([z.number(), z.string()]).optional(),
		goals: z.unknown().optional(),
		crest: crestSchema.optional(),
	})
	.passthrough();

export const homeFixtureSchema = z
	.object({
		id: z.string().optional(),
		optaId: z.number().optional(),
		optaCityTeamId: z.number().optional(),
		period: z.string().optional(),
		venue: z
			.object({
				id: z.string().optional(),
				name: z.string().optional(),
				country: z.string().optional(),
				venueType: z.string().optional(),
			})
			.passthrough()
			.optional(),
		competition: z
			.object({
				name: z.string().optional(),
				id: z.number().optional(),
				stage: z.string().optional(),
				season: z.number().optional(),
				crest: z.unknown().optional(),
			})
			.passthrough()
			.optional(),
		kickoff: z
			.object({
				kickOff: z.string().optional(),
				adjustedKickOff: z
					.object({
						kickOff: z.string().optional(),
						timezone: z.string().optional(),
					})
					.passthrough()
					.optional(),
				hideTbcDate: z.boolean().optional(),
				hideTbcTime: z.boolean().optional(),
				dateSpecificity: z.string().optional(),
			})
			.passthrough()
			.optional(),
		homeTeam: teamSchema.optional(),
		awayTeam: teamSchema.optional(),
		tickets: z
			.object({
				ticketNoticeText: z.string().optional(),
				buyTicketsLink: z.string().optional(),
				buyTicketsLinkText: z.string().optional(),
				ticketsAvailableText: z.string().optional(),
				noTicketsAvailableText: z.string().optional(),
				ticketTypes: z.unknown().optional(),
			})
			.passthrough()
			.optional(),
		webPageUrl: z.string().optional(),
		matchDayCentreUrl: z.string().optional(),
		commentaryId: z.unknown().optional(),
		dateUpdated: z.string().optional(),
	})
	.passthrough();
